import useHandleError from '@/hooks/use-handle-error'
import { Button, Modal, ModalFooter, ModalHeader } from 'jobseeker-component-ui'
import { AlertCircle } from 'lucide-react'

interface ErrorResponse {
  errors?: Record<string, string[]>
  message?: string
}

const ErrorModal = () => {
  const { show, error, closeError } = useHandleError()

  const formatErrorMessage = (error: ErrorResponse): string => {
    const messages: string[] = []

    if (error?.errors) {
      Object.entries(error.errors).forEach(([_field, errorMessages]) => {
        errorMessages.forEach((message) => {
          messages.push(` ${message}`)
        })
      })
    }

    if (error?.message) {
      messages.push(error.message)
    }

    return messages.length > 0 ? messages.join('\n') : 'An error occurred. Please try again.'
  }

  return (
    <Modal show={show}>
      <ModalHeader onClose={closeError}></ModalHeader>
      <div className="p-4">
        <div className="mb-4 flex items-center justify-center">
          <AlertCircle size={64} className="text-red-600" />
        </div>
        <div className="mb-2 text-center text-lg font-bold">Error</div>
        <div className="whitespace-pre-line text-center text-gray-700">{error ? formatErrorMessage(error) : ''}</div>
      </div>
      <ModalFooter>
        <Button onClick={closeError} color="primary">
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ErrorModal
